export const MOBILE_SCROLL_HEIGHT = 16000;

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/miniptofficial',
  youtube: 'https://www.youtube.com/@miniPT.',
  twitter: 'https://twitter.com',
};

/**
 * Set to `true` to show the analytics consent banner before any tracking starts.
 * Set to `false` to allow data collection without a consent prompt (temporary).
 */
export const REQUIRE_ANALYTICS_CONSENT = false;

export const HIDE_SECTIONS = {
  BLOG: true,
  MEDIA_REPORTS: true,
};
